import { useMutation, useQuery } from '@tanstack/react-query';

// Services
import { getDashboard, postDashboardAction } from './dashboardService';

export const DASHBOARD_QUERY_KEY = 'dashboard';

/**
 * Get dashboard data
 * @param {string} path - The path of the page (contains class_id and id)
 * @param {string} contexte - The context
 * @param {QueriesOptions} [options = {}] - The query options
 * @returns {import('@tanstack/react-query').UseQueryResult<ApiDashboardResponse, Error>} The dashboard data
 */
export const useDashboard = (path, contexte, options = {}) => useQuery({
  queryKey: [DASHBOARD_QUERY_KEY, path, contexte],
  queryFn: () => getDashboard(path, contexte),
  ...options,
});

/**
 * Mutation hook to execute a dashboard action via POST
 * @param {import('@tanstack/react-query').UseMutationOptions<ApiDashboardActionResult, Error, { id: string, actionUrl: string }, any>} [options = {}] - The mutation options
 * @returns {import('@tanstack/react-query').UseMutationResult<ApiDashboardActionResult, Error, { id: string, actionUrl: string }, any>} The dashboard action mutation
 */
export const useDashboardActionMutation = (options = {}) => useMutation({
  mutationFn: ({ actionUrl }) => postDashboardAction(actionUrl),
  ...options,
});
